module.exports = __webpack_public_path__ + "img/calendar.4fba0d1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/calendar.png
// module id = sRQ+
// module chunks = 3